import { Store } from "vuex";
import { ActionTree } from "vuex";
import { IRootState } from "./types";
import { buildAction } from "./utils";

export const actionNames = {
  SET_ROUTE: "route"
};

export const actions: ActionTree<IRootState, IRootState> = {
  [actionNames.SET_ROUTE]({ commit }, name: string | undefined) {
    commit(actionNames.SET_ROUTE, name);
  }
};

export const getActions = (store: Store<IRootState>) => ({
  updateRoute: buildAction<string | undefined>(store, "", actionNames.SET_ROUTE)
});
